import { Box, Popover } from '@mui/material';
import { colors, IconButton } from '@sweep-io/sweep-design';
import { Delete, MoreActionsHorizontal, NotePencil, Show } from '@sweep-io/sweep-design/dist/icons';
import { Dispatch, SetStateAction, useState } from 'react';
import { StyledMenuItem } from './StyledMenuItem';
import { useRoleManagerContext } from '../RoleManagerContext';
import { UserDefinedRoleGroupsInterface, RoleGroupType } from '@server/role-group-interface';
import ConfirmDestructiveDialog from '../../../common/dialogs/ConfirmDestructiveDialog';
import { useRoleGroups } from '../useRoleManager';

export const ActionMenu = ({
  role,
  anchorEl,
  setAnchorEl,
}: {
  role: UserDefinedRoleGroupsInterface;
  anchorEl?: HTMLButtonElement;
  setAnchorEl: Dispatch<SetStateAction<HTMLButtonElement | undefined>>;
}) => {
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const { initializeEditRole } = useRoleManagerContext();
  const { deleteRoleGroup, isDeletingUser } = useRoleGroups();

  const isCustomRole = role.type === RoleGroupType.USER_CREATED;

  const renderCustomRoleMenu = () => (
    <>
      <StyledMenuItem
        text="Edit"
        icon={<NotePencil size="medium" />}
        onClick={() => initializeEditRole(role)}
      />
      <StyledMenuItem
        color={colors.blush[500]}
        text="Delete"
        icon={<Delete color={colors.blush[500]} size="medium" />}
        onClick={() => setIsDeleteDialogOpen(true)}
      />
    </>
  );

  const renderSystemRoleMenu = () => (
    <StyledMenuItem
      text="View"
      icon={<Show size="medium" />}
      onClick={() => initializeEditRole(role)}
    />
  );

  return (
    <Box onClick={(e) => e.stopPropagation()}>
      <ConfirmDestructiveDialog
        onConfirm={() => {
          deleteRoleGroup(role.id);
          setIsDeleteDialogOpen(false);
          setAnchorEl(undefined);
        }}
        onClose={() => {
          setIsDeleteDialogOpen(false);
          setAnchorEl(undefined);
        }}
        open={isDeleteDialogOpen}
        confirmText={'Delete'}
        cancelText={'Cancel'}
        title={'Are you sure you want to delete?'}
      >
        Delete {role.name} role permanently?
      </ConfirmDestructiveDialog>

      <IconButton
        size="small"
        variant="flat"
        onClick={(event) => {
          event.stopPropagation();
          setAnchorEl(event.currentTarget);
        }}
        loading={isDeletingUser}
        disabled={isDeletingUser}
      >
        <MoreActionsHorizontal size="medium" />
      </IconButton>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(undefined)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Box
          sx={{ p: 1, width: '217px' }}
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          {isCustomRole && renderCustomRoleMenu()}
          {!isCustomRole && renderSystemRoleMenu()}
        </Box>
      </Popover>
    </Box>
  );
};
